import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-full-dialog-header',
  template: `
    <div class="modal-header modal-header--full">
      <div class="d-flex align-items-center w-100">
        <button type="button"
                *ngIf="!disabledBack"
                class="d-inline-flex btn btn-link link-light no-hover" aria-label="Close"
                (click)="clickClose()">
          <pt-icon [key]="IconClose" [size]="18"></pt-icon>
        </button>

        <div *ngIf="disabledBack" class='spinner-border spinner-border-sm me-2' role='status'>
          <span class='visually-hidden'>Loading...</span>
        </div>

        <pt-icon *ngIf="titleIcon" [key]="titleIcon" [size]="18" class="me-2"></pt-icon>

        <h4 class="preview-title" [innerHTML]="title"></h4>

        <div class="left">
          <ng-content select="[left]">
          </ng-content>
        </div>


        <div class="center">
          <ng-content select="[center]">
          </ng-content>
        </div>

        <div class="right">
          <ng-content select="[right]">
          </ng-content>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .preview-title {
      font-size: 14px;
      display: inline-flex;
      margin: 0;
    }

    .modal-header--full {
      width: 100%;
      background: #333;
      color: white;
      height: 48px;
      line-height: 1;
      margin-right: 12px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      border: 0;
      justify-content: space-between;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
    }

    .modal-header--full, .left {
      margin-right: auto;
    }

    .modal-header--full, .right {
      margin-left: auto;
    }
  `]
})
export class FullDialogHeaderComponent implements OnInit {
  IconClose = IoniconsOutline.arrowLeft;

  @Output() close = new EventEmitter<string>();

  @Input() titleIcon: string;

  @Input() title: string;

  disabledBack = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  clickClose() {
    this.disabledBack = true;
    this.close.emit();
  }

}
